import {BaseEntity} from "../common/baseEntity";
/**
 * Created by alex.y on 9/7/2017.
 */
export class Company extends BaseEntity<number> {
    public Name: string;

    public constructor(){
        super();
    }
}


// WEBPACK FOOTER //
// ./app/objects/customers/company.ts